export default {
  name: 'progress-bar',

  data () {
    return {
    }
  },
  props: {
    progressPerc: {
      type: Number,
      default: 0
    },
    isBannerImgUploadStart: Boolean
  },
  methods: {
    setUploader () {
      // let $0 = this
      let progressBar = document.getElementById('progressContainer')
      let valueContainer = document.getElementById('mainContent')
      let progressValue = 0
      let progressEndValue = this.progressPerc
      let progress = setInterval(() => {
        progressValue++
        if (valueContainer) {
          valueContainer.textcontent = progressValue
        }
        if (progressBar) {
          progressBar.style.background = `conic-gradient(#cadcff ${360 - (progressValue * 3.6)}deg,#1A73E8 ${360 - (progressValue * 3.6)}deg)`
        }
        if (progressValue >= progressEndValue) {
          clearInterval(progress)
        }
      })
    }
  },

  mounted () {
    this.setUploader()
  },
  watch: {
    progressPerc: function () {
      this.setUploader()
    }
  }
}
